export default __webpack_public_path__ + "static/about-1-419840fe19126321b52cf8707e707751.jpeg";